module.exports = __webpack_public_path__ + "img/receipt.d7b65069.svg";